function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from "react";
import PropTypes from "prop-types";
import { RadioButtonChecked as Checked, RadioButtonUnchecked as Unchecked } from "../../icons";
import RadioGroup, { RadioContext, getInputProps } from "./RadioGroup";
import RadioButton from "./RadioButton";
import { onRadioKeyPress } from "../../helpers";
import { useId } from "../../helpers/hooks";
const Radio = _ref => {
  let {
    label,
    className,
    style,
    ...props
  } = _ref;
  const id = useId();
  const labelId = `texada-ui-radio-${id}`;
  const context = useContext(RadioContext);
  const inputProps = getInputProps(context, props);
  const Icon = inputProps.checked ? Checked : Unchecked;
  return /*#__PURE__*/React.createElement("div", {
    className: `tui-radio ${inputProps.checked ? "checked" : ""} ${className}`,
    role: "radio",
    "aria-checked": inputProps.checked,
    tabIndex: inputProps.disabled ? -1 : 0,
    disabled: inputProps.disabled,
    onKeyPress: onRadioKeyPress(labelId),
    style: style
  }, /*#__PURE__*/React.createElement("input", _extends({}, inputProps, {
    id: labelId,
    tabIndex: "-1",
    type: "radio"
  })), /*#__PURE__*/React.createElement(Icon, null), label && /*#__PURE__*/React.createElement("label", {
    htmlFor: labelId
  }, label));
};
Radio.displayName = "Radio";
Radio.defaultProps = {
  checked: undefined,
  value: undefined,
  label: undefined,
  className: "",
  style: undefined
};
Radio.propTypes = {
  checked: PropTypes.bool,
  value: PropTypes.any,
  label: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object
};
Radio.Group = RadioGroup;
Radio.Button = RadioButton;
export default Radio;
//# sourceMappingURL=Radio.js.map